import { ITableAccountGeneral } from '../../types';

export const defaultValuesTableForm = (current: Partial<ITableAccountGeneral> | undefined) => ({
  status: current?.status || 'AVAILABLE',
  customers: current?.customers || 0,
  name: current?.name || '',
  figure: current?.figure || 'triangle',
});
